import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/5_5.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Z przyjemnością, a daleko do tego Tarszewa?"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p14,
            }}
            content={
                <div>
                    <ul>
                        <li>A daleko do tego Tarszewa?</li>
                        <li>Na piechotę kawałek i buty można przemoczyć na łąkach… A w niejednej rodzinie w tych stronach buty się na spółę nosi! Ale my pojedziemy wozem, prosto z knajpy Łukaszewskiego! Po drodze pokażę ci nasze łąki, a na nich stada słynnych, zagórowskich gęsi! – rozgaduje się Emil. – Mamy ich tu tysiące! W środę jest targ w miasteczku, zobaczysz, jak wyglądają jarmarki w Zagórowie. A znajdziesz na nich wszystko!</li>
                    </ul>
                </div>
            }
        />

    );
}